import { render, staticRenderFns } from "./hive-conf-form.vue?vue&type=template&id=b4272c98&scoped=true&"
import script from "./hive-conf-form.vue?vue&type=script&lang=ts&"
export * from "./hive-conf-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4272c98",
  null
  
)

export default component.exports